<template>
  <div
    v-if="!isHide"
    :class="[_.proxy, `proxy_${normalizedItem.componentType}`]"
    :style="{
      '--margin-top': $transformPx(normalizedItem.theme.marginTop || 0),
      '--margin-left': $transformPx(normalizedItem.theme.marginBoth || 0),
      '--margin-right': $transformPx(normalizedItem.theme.marginBoth || 0),
      '--padding-top': $transformPx(normalizedItem.theme.paddingTop || 0),
      '--padding-right': $transformPx(normalizedItem.theme.paddingRight || 0),
      '--padding-bottom': $transformPx(normalizedItem.theme.paddingBottom || 0),
      '--padding-left': $transformPx(normalizedItem.theme.paddingLeft || 0),
      '--border-radius': $transformPx(
        normalizedItem.theme.borderStyle === 'circle' ? 8 : 0,
      ),
      '--color': normalizedItem.theme.fontColor || 'black',
      ...(normalizedItem.theme.backgroundType && normalizedItem.theme.background
        ? normalizedItem.theme.backgroundType === 'color'
          ? {
              backgroundColor: normalizedItem.theme.background,
            }
          : {
              backgroundImage: `url(${normalizedItem.theme.background})`,
            }
        : undefind),
      '--leftBackground': `url(${normalizedItem.theme.leftBackground})`,
      '--rightBackground': `url(${normalizedItem.theme.rightBackground})`,
    }"
  >
    <component
      :is="sourceComponent"
      v-bind="normalizedItem"
      @hide="isHide = true"
    >
      <slot />
    </component>
  </div>
</template>

<script>
  import Vue from 'vue'

  const sourceComponentMap = {
    // @index('../*__*', (f, _) => { let [a, b] = f.name.split('__'); return `${b}: 'Dmbc${_.pascal(f.name)}',` })
    USE_RULE: 'Dmbc使用规则UseRule',
    COMMODITY_LAYER: 'Dmbc商品宫格CommodityLayer',
    CLASSIFY_COMMODITY: 'Dmbc商品推荐ClassifyCommodity',
    COMMODITY_ROTATION: 'Dmbc商品橱窗CommodityRotation',
    MARKETING_SCENE: 'Dmbc商品橱窗2MarketingScene',
    COMMODITY_FEED: 'Dmbc商品瀑布流CommodityFeed',
    COMMODITY_FEED_2023_APPLIANCE: 'Dmbc商品瀑布流CommodityFeed_2023Appliance',
    COMMODITY_EVALUATE: 'Dmbc商品评论CommodityEvaluate',
    CLASSIFY: 'Dmbc图标宫格Classify',
    IMAGE_LAYER: 'Dmbc图片宫格ImageLayer',
    STORE_DISCOUNT: 'Dmbc店铺优惠券StoreDiscount',
    STORE_NOTICE: 'Dmbc店铺公告StoreNotice',
    STORE_LABEL: 'Dmbc店铺关键词StoreLabel',
    STORE_HEAD: 'Dmbc店铺头部StoreHead',
    ARTICLE_ITEM: 'Dmbc文章列表ArticleItem',
    COMMON_LIST: 'Dmbc普通列表CommonList',
    SKILL_ACTIVITY: 'Dmbc秒杀SkillActivity',
    DESCRIPTION: 'Dmbc简介Description',
    CUSTOM: 'Dmbc自定义区块Custom',
    CLASSIFY_FEED: 'Dmbc资源瀑布流ClassifyFeed',
    ACTIVITY_FEED: 'Dmbc资源瀑布流2ActivityFeed',
    BANNER: 'Dmbc轮播Banner',
    PAGE: 'Dmbc页面Page',
    PAGE_HEAD: 'Dmbc页面头部PageHead',
    COUPON: 'Dmbc领券Coupon',
    COUPON_2023_APPLIANCE: 'Dmbc领券Coupon_2023Appliance',
    // @endindex
  }

  export default Vue.extend({
    inject: {
      pageTheme: 'pageTheme',
    },

    props: {
      pageId: {
        type: Object,
        required: true,
      },
      pageName: {
        type: Object,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      isHide: false,
    }),

    computed: {
      normalizedItem() {
        return {
          data: this.item.data,
          theme: {
            ...this.item.style,
            marginTop: this.item.style.marginTop ?? this.pageTheme?.marginTop,
            marginBoth:
              this.item.style.marginBoth ?? this.pageTheme?.marginBoth,
          },
          componentType: this.item.style.styleId || this.item.type,
          componentId: this.item.id,
          pageId: this.pageId,
          pageName: this.pageName,
          pageTheme: this.pageTheme,
        }
      },
      sourceComponent() {
        return sourceComponentMap[this.normalizedItem.componentType]
      },
    },
  })
</script>

<style lang="scss" module="_">
  .proxy {
    position: relative;
    display: flex;
    margin: var(--margin-top) var(--margin-left) 0 var(--margin-right);
    border-radius: var(--border-radius);
    background-size: 100% auto;
    background-repeat: repeat-y;
    background-position: top;

    &:not(:global(.proxy_PAGE)) > * {
      flex: 1;
    }

    &:not(:global(.proxy_PAGE)):not(:global(.proxy_DESCRIPTION)) > * {
      overflow: hidden;
    }
  }
</style>
